<div [formGroup]="addUserForm" style="width: 50vw;">
  <div class="content-wrapper">
    <div class="content">
      <div class="section">
        <div class="section-heading">
          Basic Details
        </div>
        <div class="section-content">
          <div class="neo-grid neo-grid-cols-2">
            <div class="neo-input-wrapper">
              <label for="first_name" required>First Name</label>
              <input type="text" id="first_name" pInputText formControlName="first_name" class="form-input"
                [class.error]="clicked && addUserForm.controls['first_name'].errors" placeholder="Enter first name" />
              <app-handle-error [clicked]="clicked" [control]="addUserForm.get('first_name')" name="First Name"></app-handle-error>
            </div>
            <div class="neo-input-wrapper">
              <label for="last_name" required>Last Name</label>
              <input id="last_name" type="text" pInputText formControlName="last_name" class="form-input"
                [class.error]="clicked && addUserForm.controls['last_name'].errors" placeholder="Enter last name" />
              <app-handle-error [clicked]="clicked" [control]="addUserForm.get('last_name')" name="Last Name"></app-handle-error>
            </div>
          </div>
          <div class="neo-grid neo-grid-cols-2">
            <div class="neo-input-wrapper">
              <label for="official_email_id" required>Official Email ID</label>
              <input id="official_email_id" type="email" pInputText formControlName="email" class="form-input"
                [class.error]="clicked && addUserForm.controls['email'].errors" placeholder="Enter email address" />
              <app-handle-error [clicked]="clicked" [control]="addUserForm.get('email')" name="Email"></app-handle-error>
            </div>
            <div class="neo-input-wrapper">
              <label for="mobile_number" required>Mobile Number</label>
              <input id="mobile_number" (keypress)="restrictNumber($event)" [maxlength]="10" type="tel" pInputText formControlName="mobile_number"
                class="form-input" [class.error]="clicked && addUserForm.controls['mobile_number'].errors"
                placeholder="Enter mobile number" />
              <app-handle-error [clicked]="clicked" [control]="addUserForm.get('mobile_number')"
                name="Mobile Number"></app-handle-error>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="section-heading">
          Role & Authentication Details
        </div>
        <div class="section-content">
          <div class="neo-input-wrapper">
            <label for="associated_role" required>Associated Role</label>
            <p-select bigger inputId="associated_role" [options]="associativeRoles" appendTo="body" formControlName="role_id"
              optionLabel="label" optionValue="value" (onChange)="onClick()" placeholder="Select role"
              #ms
              [panelStyle]="{
                  'min-width': ms.el.nativeElement.offsetWidth + 'px',
                  'max-width': ms.el.nativeElement.offsetWidth + 'px'
              }"
              [styleClass]="clicked && addUserForm.controls['role_id'].errors ? 'error' : ''" class="form-dropdown">
            </p-select>
            <app-handle-error [clicked]="clicked" [control]="addUserForm.get('role_id')" name="Role"></app-handle-error>
            <div class="info-box" *ngIf="addUserForm.value.role_id && showInfo">{{ dis }}</div>
          </div>
          <div class="form-group">
            <div class="checkbox-wrapper">
              <p-checkbox formControlName="is_sso_user" [binary]="true" inputId="sso_user">
              </p-checkbox>
              <label for="sso_user" class="checkbox-label">
                Allow user through SSO login
              </label>
            </div>
            <div class="checkbox-description">
              When enabled, this user can authenticate using SSO providers.
            </div>
          </div>
          <div class="form-group">
            <div class="checkbox-wrapper">
              <p-checkbox formControlName="is_active" [binary]="true" inputId="is_active_user">
              </p-checkbox>
              <label for="is_active_user" class="checkbox-label">
                Active user
              </label>
            </div>
            <div class="checkbox-description">
              When enabled, this user account will be active and able to log in.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog-action">
    <button pButton pRipple type="submit" (click)="saveUser()" [loading]="saveBtnLoading" label="Save"
      class="create-btn"></button>
  </div>
</div>

@if (false) {
<div class="form-container">
    <div class="form-header">
      <div class="header-icon">
        <i class="pi pi-user"></i>
      </div>
      <h2 class="header-title">{{ userHeader }}</h2>
    </div>
  
    <div class="form-content">
      <form [formGroup]="addUserForm" (ngSubmit)="onSave()">
  
        <div class="form-section">
          <div class="section-header">
            <i class="pi pi-info-circle section-icon"></i>
            <h3 class="section-title">Basic Information</h3>
          </div>
          
          <div class="form-group">
            <label class="form-label">First Name <span class="required">*</span></label>
            <input 
              type="text" 
              pInputText 
              formControlName="first_name"
              class="form-input"
              [class.error]="clicked && addUserForm.controls['first_name'].errors"
              placeholder="Enter first name" />
            <app-handle-error [clicked]="clicked" [control]="addUserForm.get('first_name')" name="First Name"></app-handle-error>
          </div>
  
          <div class="form-group">
            <label class="form-label">Last Name <span class="required">*</span></label>
            <input 
              type="text" 
              pInputText 
              formControlName="last_name"
              class="form-input"
              [class.error]="clicked && addUserForm.controls['last_name'].errors"
              placeholder="Enter last name" />
            <app-handle-error [clicked]="clicked" [control]="addUserForm.get('last_name')" name="Last Name"></app-handle-error>
          </div>
  
          <div class="form-group">
            <label class="form-label">Official Email ID <span class="required">*</span></label>
            <input 
              type="email" 
              pInputText 
              formControlName="email"
              class="form-input"
              [class.error]="clicked && addUserForm.controls['email'].errors"
              placeholder="Enter email address" />
            <app-handle-error [clicked]="clicked" [control]="addUserForm.get('email')" name="Email"></app-handle-error>
          </div>
  
          <div class="form-group">
            <label class="form-label">Mobile Number <span class="required">*</span></label>
            <input 
              (keypress)="restrictNumber($event)" 
              [maxlength]="10" 
              type="tel" 
              pInputText 
              formControlName="mobile_number"
              class="form-input"
              [class.error]="clicked && addUserForm.controls['mobile_number'].errors"
              placeholder="Enter mobile number" />
            <app-handle-error [clicked]="clicked" [control]="addUserForm.get('mobile_number')" name="Mobile Number"></app-handle-error>
          </div>
        </div>
        <div class="form-section">
          <div class="section-header">
            <i class="pi pi-shield section-icon"></i>
            <h3 class="section-title">Role & Authentication</h3>
          </div>
          
          <div class="form-group">
            <label class="form-label">Associated Role <span class="required">*</span></label>
            <div class="dropdown-wrapper">
              <p-select 
                [options]="associativeRoles"
                formControlName="role_id"
                optionLabel="label"
                optionValue="value"
                (onChange)="onClick()"
                placeholder="Select role"
                [styleClass]="clicked && addUserForm.controls['role_id'].errors ? 'error' : ''"
                class="form-dropdown">
              </p-select>
            </div>
            <app-handle-error [clicked]="clicked" [control]="addUserForm.get('role_id')" name="Role"></app-handle-error>
            <div class="info-box" *ngIf="addUserForm.value.role_id && showInfo">{{ dis }}</div>
          </div>
  
          <div class="form-group">
            <div class="checkbox-wrapper">
              <p-checkbox 
                formControlName="is_sso_user"
                [binary]="true"
                inputId="sso_user">
              </p-checkbox>
              <label for="sso_user" class="checkbox-label">
                Allow user through SSO login
              </label>
            </div>
            <div class="checkbox-description">
              When enabled, this user can authenticate using SSO providers.
            </div>
          </div>
          <div class="form-group">
            <div class="checkbox-wrapper">
              <p-checkbox 
                formControlName="is_active"
                [binary]="true"
                inputId="is_active_user">
              </p-checkbox>
              <label for="is_active_user" class="checkbox-label">
                Active user
              </label>
            </div>
            <div class="checkbox-description">
              When enabled, this user account will be active and able to log in.
            </div>
          </div>
        </div>
      </form>
    </div>
  
    <div class="form-footer">
      <button type="button" class="cancel-btn" (click)="cancel()">
        Clear
      </button>
      <button pButton pRipple type="submit" (click)="saveUser()" [loading]="saveBtnLoading" label="Save"
        class="save-btn"></button>
    </div>
  </div>
}

<p-toast></p-toast>